import { Snackbar, Alert } from '@mui/material';
import React from 'react';
import type { SnackbarProps } from '@mui/material/Snackbar';
import type { AlertProps } from '@mui/material/Alert';

interface SnackbarRef {
    show: (message: string, severity: 'success' | 'info' | 'warning' | 'error') => void;
}

class NotificationService {
    private static instance: NotificationService;
    private snackbarRef: SnackbarRef | null;

    private constructor() {
        this.snackbarRef = null;
    }

    static getInstance(): NotificationService {
        if (!NotificationService.instance) {
            NotificationService.instance = new NotificationService();
        }
        return NotificationService.instance;
    }

    setSnackbarRef(ref: SnackbarRef) {
        this.snackbarRef = ref;
    }

    show(message: string, severity: 'success' | 'info' | 'warning' | 'error' = 'info') {
        if (this.snackbarRef) {
            this.snackbarRef.show(message, severity);
        }
    }
}

export const notificationService = NotificationService.getInstance();

export const GlobalNotification: React.FC = () => {
    const [open, setOpen] = React.useState(false);
    const [message, setMessage] = React.useState('');
    const [severity, setSeverity] = React.useState<'success' | 'info' | 'warning' | 'error'>('info');

    React.useEffect(() => {
        notificationService.setSnackbarRef({
            show: (msg: string, sev: 'success' | 'info' | 'warning' | 'error') => {
                setMessage(msg);
                setSeverity(sev);
                setOpen(true);
            }
        });
    }, []);

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Snackbar anchorOrigin={{vertical: 'top', horizontal: 'center'}} open={open} autoHideDuration={30000} onClose={handleClose}>
            <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
                {message}
            </Alert>
        </Snackbar>
    );
}; 